import { Globe } from 'lucide-react';
import { useTranslation, Language } from '../hooks/useTranslation';

export function LanguageSwitcher() {
  const { language, changeLanguage } = useTranslation();

  const languages = [
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'th', name: 'ไทย', flag: '🇹🇭' },
    { code: 'lo', name: 'ລາວ', flag: '🇱🇦' },
    { code: 'km', name: 'ខ្មែរ', flag: '🇰🇭' },
  ] as const;

  const currentLanguage = languages.find(lang => lang.code === language);

  const handleLanguageChange = (newLanguage: Language) => {
    console.log('LanguageSwitcher: Changing to', newLanguage); // Debug log
    changeLanguage(newLanguage);
  };

  return (
    <div className="relative group">
      <button className="flex items-center space-x-2 px-3 py-2 text-slate-700 hover:text-emerald-600 transition-colors">
        <Globe className="w-5 h-5" />
        <span className="text-lg">{currentLanguage?.flag}</span>
        <span className="text-sm font-medium">{currentLanguage?.name}</span>
      </button>

      {/* Dropdown */}
      <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-slate-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <div className="py-2">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code as Language)}
              className={`w-full px-4 py-2 text-left hover:bg-slate-50 transition-colors flex items-center space-x-3 ${
                language === lang.code ? 'bg-emerald-50 text-emerald-600' : 'text-slate-700'
              }`}
            >
              <span className="text-lg">{lang.flag}</span>
              <span className="font-medium">{lang.name}</span>
              {language === lang.code && (
                <div className="ml-auto w-2 h-2 bg-emerald-500 rounded-full"></div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
